import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Check } from "lucide-react";

// 375: částky dokladu jako dlaždice (faktura i účtenka). Čtyři vedle sebe, jen když se do nich všechny částky
// vejdou celé, jinak 2 × 2 — nic se neusekne ani nezalomí (detail vedle tabulky je užší než okno).
export function AmountTiles({ children, testid }) {
  const ref = useRef(null);
  const [cols, setCols] = useState(4);
  const fit = useCallback(() => {
    const el = ref.current;
    if (!el || !el.clientWidth) return;
    const need = Math.max(0, ...[...el.querySelectorAll("[data-amt]")].map((n) => n.offsetWidth)) + 36;   // + odsazení dlaždice
    setCols(el.clientWidth / 4 >= need ? 4 : 2);
  }, []);
  useLayoutEffect(fit);   // každé vykreslení — částky se mění při psaní
  useEffect(() => {
    if (typeof ResizeObserver === "undefined" || !ref.current) return undefined;
    const ro = new ResizeObserver(fit);
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, [fit]);
  return (
    <div ref={ref} data-testid={testid} data-cols={cols}
      className={`grid ${cols === 4 ? "grid-cols-4" : "grid-cols-2"} gap-px rounded-[18px] border border-border bg-border overflow-hidden`}>
      {children}
    </div>
  );
}

// tone: "brand" (K úhradě) / "success" (Zaplaceno u účtenky); title = přesná částka po najetí myší
export function AmountTile({ label, value, title, sub, tone, testid }) {
  const ink = tone === "brand" ? "text-brand" : tone === "success" ? "text-success" : "";
  return (
    <div className="bg-card min-w-0" data-testid={testid} title={title}>
      <div className={`h-full px-4 py-3 ${tone === "brand" ? "bg-brand/[0.07]" : tone === "success" ? "bg-success/[0.08]" : ""}`}>
        <div className={`text-[13px] truncate flex items-center gap-1.5 ${tone === "success" ? "text-success" : "text-muted-foreground"}`}>{tone === "success" && <Check size={14} />}{label}</div>
        <div className="mt-0.5 min-w-0 overflow-hidden">
          <span data-amt className={`inline-block whitespace-nowrap font-heading font-extrabold text-lg md:text-xl tabular-nums ${ink}`}>{value}</span>
        </div>
        {sub && <div className="text-xs text-muted-foreground tabular-nums truncate">{sub}</div>}
      </div>
    </div>
  );
}
